import { useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { Box, Button } from '@mui/material';
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline';
import ErrorOutlineIcon from '@mui/icons-material/ErrorOutline';

import OtpForm from '../../ui/layout/otp-form';
import StatusModal from '../../ui/modal/status-modal';
import Services from '../../../services';
import { IStatusModal } from '../../../interfaces/modal.interface';
import { OTP_CONSTANT } from '../../../constants/otp.constant';

const styles = {
  container: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    width: '100%',
  },

  OtpContainer: {
    display: 'flex',
    flexDirection: 'column',
    textAlign: 'center',
    alignItems: 'center',
    width: '100%',
    maxWidth: '25rem',
  },
  iconSuccess: {
    color: '#29B097',
    fontSize: 90,
    mb: '2rem',
  },
  iconError: {
    color: 'red',
    fontSize: 90,
    mb: '2rem',
  },

  cancelButton: { p: 2 },
};

const EmployeeOtpForm = () => {
  const navigate = useNavigate();
  const { slug } = useParams();

  const [token, setToken] = useState<string>('');
  const [modalOptions, setModalOptions] = useState<IStatusModal>();

  const onSubmitHandler = async () => {
    if (slug) {
      const { success } = await Services.api.employee.validateOTP({ slug, token });

      if (success) {
        setModalOptions({
          open: true,
          type: 'success',
          icon: <CheckCircleOutlineIcon sx={styles.iconSuccess} />,
          heading: OTP_CONSTANT.success.status,
          message: OTP_CONSTANT.success.message,
          buttonLabel: OTP_CONSTANT.success.buttonMsg,
        });
      } else {
        setModalOptions({
          open: true,
          type: 'error',
          icon: <ErrorOutlineIcon sx={styles.iconError} />,
          heading: OTP_CONSTANT.error.status,
          message: OTP_CONSTANT.error.message,
          buttonLabel: OTP_CONSTANT.error.buttonMsg,
        });
      }
    }
  };

  const onCloseModalHandler = () => {
    setModalOptions((prev: any) => {
      return {
        ...prev,
        open: false,
      };
    });

    if (modalOptions?.type === 'success') {
      navigate('/');
    } else {
      setToken('');
    }
  };

  return (
    <Box sx={styles.container}>
      {modalOptions && <StatusModal onClose={onCloseModalHandler} options={modalOptions} />}

      <Box sx={styles.OtpContainer}>
        <OtpForm
          token={token}
          onChange={(e: string) => {
            setToken(e);
          }}
          onClick={onSubmitHandler}
        />

        <Button
          fullWidth
          type='button'
          variant='contained'
          color='inherit'
          onClick={() => {
            navigate('/');
          }}
          sx={{
            p: 2,
            mt: '0.625rem',
          }}
        >
          Cancel
        </Button>
      </Box>
    </Box>
  );
};

export default EmployeeOtpForm;
